import { buildCalendarVisitSchedule } from '../calendarVisitSchedule.schema';
import { shouldIncludeAsCalendarVisitSchedule } from './shouldIncludeAsCalendarVisitSchedule';

/**
 * Filters and transforms an array of padVisits based on context.
 */
export const filterAndTransformPadVisitsToCalendarVisitSchedule = padVisits => {
  if (!Array.isArray(padVisits)) return [];

  return padVisits
    .filter(padVisit => shouldIncludeAsCalendarVisitSchedule(padVisit))
    .map(transformPadVisitToCalendarVisitSchedule);
};

/**
 * Transforms a single padVisit into a genericVisit structure.
 * Pure function with no side effects.
 */
export const transformPadVisitToCalendarVisitSchedule = padVisit =>
  buildCalendarVisitSchedule(padVisit);
